import React, { useState } from "react";
import { Receipt } from "phosphor-react";
import PropTypes from "prop-types";
import InputField from "components/Input";
import "./index.scss";
import SelectCountry from "components/block/SelectCountry";

const BillingDetails = ({
  formik,
  country,
  handleSelectCountry,
  countryError,
}) => {
  const [onAdd, setOnAdd] = useState(false);

  return (
    <div className="payment-billing-details">
      <h2>Billing Details</h2>
      <div className="icon-wrapper">
        <Receipt size={32} color="#070C1E" />
      </div>
      <InputField
        id="name"
        placeholder="Full name"
        label="Full name"
        {...formik.getFieldProps("name")}
        values={formik.values.name}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.name}
      />
      <InputField
        id="companyName"
        placeholder="Company name"
        label="Company name"
        {...formik.getFieldProps("companyName")}
        values={formik.values.companyName}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.companyName}
      />
      <SelectCountry
        label="Country"
        value={country?.toUpperCase()}
        onChange={(val) => handleSelectCountry(val)}
        error={countryError}
        errorMessage={countryError}
      />
      <div className="street-address">
        <div className="input-field">
          <textarea
            className={`text-area  ${formik.errors.address1 ? "-errors" : ""}`}
            rows={3}
            id="address1"
            {...formik.getFieldProps("address1")}
            values={formik.values.address1}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.address1}
          />
          <label className="label">Street Address</label>
        </div>
        <div className="errors">
          {formik.errors.address1 ? "Enter Address" : ""}
        </div>
        <div className="add" onClick={() => setOnAdd(!onAdd)} aria-hidden>
          + Add apartment, suite or other
        </div>
        {onAdd && (
          <InputField
            id="address2"
            placeholder="Apartment, suite or other"
            label="Apartment, suite or other"
            {...formik.getFieldProps("country")}
            values={formik.values.address2}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.address2}
          />
        )}
      </div>
      <div className="inline-inputs">
        <InputField
          id="state"
          placeholder="State or Province"
          label="State or Province"
          {...formik.getFieldProps("state")}
          values={formik.values.state}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.state}
        />
        <InputField
          id="city"
          placeholder="City"
          label="City"
          {...formik.getFieldProps("city")}
          values={formik.values.city}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.city}
        />
      </div>
      <div className="inline-inputs">
        <InputField
          id="zipCode"
          placeholder="Zip Code"
          label="Zip Code"
          {...formik.getFieldProps("zipCode")}
          values={formik.values.zipCode}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.zipCode}
        />
      </div>
    </div>
  );
};

BillingDetails.defaultProps = {
  formik: {},
  handleChangeAddress: () => {},
  handleInputChange: () => {},
  validateInput: () => {},
  handleSelectCountry: () => {},
  country: "",
  countryError: "",
};

BillingDetails.propTypes = {
  formik: PropTypes.shape({
    getFieldProps: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    handleBlur: PropTypes.func.isRequired,
    values: PropTypes.shape({
      name: PropTypes.string,
      companyName: PropTypes.string,
      address1: PropTypes.string,
      address2: PropTypes.string,
      country: PropTypes.string,
      state: PropTypes.string,
      city: PropTypes.string,
      zipCode: PropTypes.string,
    }).isRequired,
    errors: PropTypes.shape({
      name: PropTypes.string,
      companyName: PropTypes.string,
      address1: PropTypes.string,
      address2: PropTypes.string,
      country: PropTypes.string,
      state: PropTypes.string,
      city: PropTypes.string,
      zipCode: PropTypes.string,
    }).isRequired,
  }),
  handleChangeAddress: PropTypes.func,
  handleInputChange: PropTypes.func,
  validateInput: PropTypes.func,
  handleSelectCountry: PropTypes.func,
  country: PropTypes.string,
  countryError: PropTypes.string,
};

export default BillingDetails;
